module.exports = __webpack_public_path__ + "static/media/ic_pencil.59b84264.svg";